import React from "react";
import { Hero } from "../sections/Hero";
import { Marquee } from "../sections/Marquee";
import { Partners } from "../sections/Partners";
import { TwoSides } from "../sections/TwoSides";
import { HowItWorks } from "../sections/HowItWorks";
import { TrustScoring } from "../sections/TrustScoring";
import { Comparison } from "../sections/Comparison";
import { ImpactStats } from "../sections/ImpactStats";
import { ProductsGrid } from "../sections/ProductsGrid";
import { FAQ } from "../sections/FAQ";
import { CTA } from "../sections/CTA";

export const Landing = () => (
  <>
    <Hero />
    <Marquee />
    <Partners />
    <TwoSides />
    <HowItWorks />
    <TrustScoring />
    <Comparison />
    <ImpactStats />
    <ProductsGrid />
    <FAQ />
    <CTA />
  </>
);
